import useApi from "../../../../Utils/BackendClient";
import { useContext, useState, useEffect, useRef, useMemo } from "react";
import { useFormik } from "formik";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Guid } from 'js-guid';

import ActNumberWithAutogenerateInput from "../../../UIElements/Inputs/ActNumberWithAutogenerateInput";
import ActPayments from "../../../UIElements/ActPayments";
import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import CheckboxInput from "../../../UIElements/Inputs/CheckboxInput";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import DocumentArchiveTable from "../../../UIElements/DocumentArchiveTable";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import EnumsContext from "../../../../context/enums-context";
import HistoryElement from "../../../UIElements/HistoryElement";
import TextInput from "../../../UIElements/Inputs/TextInput";
import { convertSumWithLatestCurrencyRate, formatCurrency, buildGroupHierarchy, getGroupCode, formatShortDate, formatQuantityWithMeasurement, systemCurrenciesDropdown, findKeyByValue, useEnumLabel } from "../../../../Utils/Utils";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Sidebar } from "primereact/sidebar";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { TreeSelect } from "primereact/treeselect";

import commonStyle from "../../CommonStyles.module.css";
import CounterAgentCreationSidebar from "../../../UIElements/Sidebars/CounterAgentCreationSiidebar";
import CurrencyAmountInput from "../../../UIElements/Inputs/CurrencyAmountInput";
import NumberInput from "../../../UIElements/Inputs/NumberInput";
import { numberEditor, textEditor } from "../../../../Utils/TableEditors";

const NewProductsReception = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const toast = useRef(null);
    const ctx = useContext(EnumsContext);
    const { createProduct, createReceptionAct, fetchActPayments, fetchProducts, fetchProductsExtended, fetchReceptionActDetails, fetchReceptionActDocuments, fetchReceptionActHistory, deletePaymentFromAct, updateReceptionAct } = useApi();

    const [actPayments, setActPayments] = useState(null);
    const [cagentCreationSidebarVisible, setCagentCreationSidebarVisible] = useState(false);
    const [docArchive, setDocArchive] = useState(null);
    const [docArchiveTotalRecords, setDocArchiveTotalRecords] = useState(0);
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [isEdit, setIsEdit] = useState(false);
    const [isEditField, setIsEditField] = useState(false);
    const [isFinalized, setIsFinalized] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 932);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [productSideBarVisible, setProductSideBarVisible] = useState(false);
    const [receptionActHistory, setReceptionActHistory] = useState(null);
    const [reloadData, setReloadData] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [showfields, setShowFields] = useState(false);
    const [showproducts, setShowProducts] = useState(false);
    const [showActBaseOnMobile, setShowActBaseOnMobile] = useState(true);
    const [sortedGroups, setSortedGroups] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [totaLActSum, setTotalActSum] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [visible, setVisible] = useState(false);
    const [lazyState, setlazyState] = useState(
        {
            first: 0,
            rows: 20,
            page: 1,
            sortField: "created_at",
            sortOrder: 1,
            filters: {
                product_group: { value: null, matchMode: 'contains' },
            }
        }
    );
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [actData, setActData] = useState({
        cagent: null,
        division: null,
        act_number_autogenerate: true,
        act_number: '',
        act_date: new Date(),
        pay_due_date: new Date(),
        status: "Драфт",
        pay_status: "Не оплачено",
        identified_products: [],
        unidentified_products: [],
    });

    const [docArchiveLazyState, setDocArchiveLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });

    const newState = {
        first: 0,
        rows: 20,
        page: 1,
        sortField: "created_at",
        sortOrder: 1,
        filters: {
            product_group: { value: null, matchMode: 'contains' },
        }
    };

    const enumTypes = useMemo(() => ["partners", "divisions", "pay_statuses"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);
    const getPartnerLabel = useEnumLabel(ctx.enums.partners.data);
    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 932);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const getProductGroups = async () => {
            const response = await fetchProductsExtended();

            if (response.status === 200) {
                const groups = buildGroupHierarchy(response.data);
                setSortedGroups(groups);
            }
            else {
                setSortedGroups([]);
            }
        }

        getProductGroups();
    }, [fetchProductsExtended]);

    useEffect(() => {
        if (location.state !== null) {

            setIsEdit(true);

            const fetchData = async () => {

                const response = await fetchReceptionActDetails(location.state.id);

                if (response.status === 200) {

                    setIsFinalized(response.data.status !== "PENDING");
                    response.data.act_date = new Date(response.data.act_date);
                    response.data.pay_due_date = new Date(response.data.pay_due_date);

                    response.data.identified_products.forEach(element => {
                        element.product_name = element.product;
                        element.product = element.product_id;
                    });

                    response.data.unidentified_products.forEach(element => {
                        element.product_name = element.product;
                        element.product = element.product_id;
                    });

                    setActData(response.data);
                }
            }

            fetchData();
        }
    }, [location.state, fetchActPayments, fetchReceptionActDetails]);

    const formik = useFormik({
        initialValues: actData,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.cagent === null || values.cagent === undefined) {
                errors.cagent = "Виберіть контрагента";
            }

            if (values.division === null || values.division === undefined) {
                errors.division = "Виберіть точку продажу";
            }

            if (!values.act_number_autogenerate) {
                if (values.act_number === null || values.act_number === "") {
                    errors.act_number = "Введіть номер акту";
                }
            }
            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            function transformDate(date) {
                const day = ('0' + date.getDate()).slice(-2); // Add leading zero if needed
                const month = ('0' + (date.getMonth() + 1)).slice(-2); // Month is zero-based, so add 1
                const year = date.getFullYear();

                const formattedDate = `${year}-${month}-${day}`;

                return formattedDate
            }

            function transformProducts(products) {
                return products.map(product => {
                    delete product.fe_id;
                    delete product.product_name;
                    return product;
                });
            }

            values.identified_products = transformProducts(values.identified_products);
            values.unidentified_products = transformProducts(values.unidentified_products);
            values.act_date = transformDate(values.act_date);
            if (values.act_number_autogenerate) {
                delete values.act_number;
            }
            values.pay_due_date = transformDate(values.pay_due_date);

            const response = isEdit ? await updateReceptionAct(location.state.id, values) : await createReceptionAct(values);

            const successStatus = isEdit ? 200 : 201;

            if(response.status === successStatus){
                let toastMessage = { severity: "success", summary: isEdit ? "Успіх редагування" : "Успіх створення", 
                    detail: isEdit ? "Акт успішно відредаговано" : "Акт успішно створено", life: 3000 };
                navigate("/productsreception", { state: { toast: toastMessage } });
            }
            else{
                toast.current.show({ severity: "error", summary: isEdit ? "Помилка редагування" : "Помилка створення", 
                    detail: isEdit ? "Акт не відредаговано" : "Акт не створено", life: 3000 })
            }

            setSubmitLoading(false);
        }
    });

    useEffect(() => {
        let calcAmount = 0;

        if (formik.values?.unidentified_products?.length > 0) {
            calcAmount += formik.values.unidentified_products.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, (prod.quantity ?? 1) * prod.price), 0);
        }

        if (formik.values?.identified_products?.length > 0) {
            calcAmount += formik.values.identified_products.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, prod.price), 0);
        }

        setTotalActSum(calcAmount);

    }, [formik.values.identified_products, formik.values.unidentified_products])

    const sideBarFormik = useFormik({
        initialValues: {
            fe_id: null,
            type: '',
            product: "",
            product_id: "",
            identifier: "",
            quantity: null,
            note: "",
            price: null,
            priceUAH: null,
            currency: "UAH",
            use_product_sale_price: false,
            catalogue_price: 0,
            catalogue_currency: "UAH",
            custom_sale_price: null,
            measurement_units: "PIECES",
            custom_sale_price_currency: "UAH"
        },
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.type === "INDIVIDUAL" && (values.identifier === null || values.identifier === "")) {
                errors.identifier = "Введіть ідентифікатор";
            }
            if (values.type !== "INDIVIDUAL") {
                if ((!values.quantity)) {
                    errors.quantity = "Введіть кількість товару";
                }
                else if (values.quantity <= 0) {
                    errors.quantity = "Кількість повинна бути вищою від 0"
                }
            }

            if (values.currency === null || values.currency === undefined) {
                errors.currency = "Виберіть валюту"
            }

            if (!values.price) {
                errors.price = "Введіть вартість в валюті акту";
            }
            else if (values.price <= 0.01) {
                errors.price = "Вартість товару повинна бути вищою від нуля";
            }

            if (values.currency !== "UAH") {
                if (!values.priceUAH) {
                    errors.priceUAH = "Введіть вартість в гривні";
                }
                else if (values.priceUAH <= 0.01) {
                    errors.priceUAH = "Вартість товару повинна бути вищою від нуля";
                }
            }

            if (!values.use_product_sale_price) {

                if (!values.custom_sale_price) {
                    errors.custom_sale_price = "Введіть вартість продажу"
                }
                else if (values.custom_sale_price <= 0.01) {
                    errors.custom_sale_price = "Вартість продажу повинна бути більшою від нуля"
                }
                if (values.custom_sale_price_currency === undefined || values.custom_sale_price_currency === "") {
                    errors.custom_sale_price_currency = "Виберіть валюту продажу"
                }
            }

            return errors;
        },
        onSubmit: (values) => {

            let newValue = {
                product_id: values.product_id,
                product_name: values.product,
                note: values.note,
                price: +values.price,
                priceUAH: +values.priceUAH,
                currency: values.currency,
                use_product_sale_price: values.use_product_sale_price,
                custom_sale_price: values.use_product_sale_price ? values.catalogue_price : +values.custom_sale_price,
                custom_sale_price_currency: values.use_product_sale_price ? values.catalogue_currency : values.custom_sale_price_currency,
                measurement_units: values.measurement_units
            };

            const arrayName = values.type === "INDIVIDUAL" ? "identified_products" : "unidentified_products";

            if (values.type === "INDIVIDUAL") {
                newValue.identifier = values.identifier;
            } else {
                newValue.quantity = values.quantity;
            }

            let updatedArray = formik.values[arrayName];

            if (!isEditField) {
                newValue.fe_id = Guid.newGuid().toString();
                updatedArray = [...updatedArray, newValue];
            }
            else {
                if (newValue.fe_id) {
                    updatedArray = updatedArray.map(item =>
                        item.fe_id === values.fe_id ? newValue : item
                    );
                }
                else {
                    newValue.id = values.id;
                    updatedArray = updatedArray.map(item =>
                        item.id === values.id ? newValue : item
                    );
                }
            }

            formik.setFieldValue(arrayName, updatedArray);

            setShowFields(false);

            if (!isEditField) {
                setShowProducts(true);
            }
            else{
                setVisible(false);
                setIsEditField(false);
            }
            sideBarFormik.resetForm();
        }
    });

    const newProductFormik = useFormik({
        initialValues: {
            product_group: null,
            product_name: "",
            product_article: "",
            price: null,
            currency: "UAH",
            is_active: true,
            attributes_values: []
        },
        validate: values => {
            const errors = {};

            if (!values.product_name) {
                errors.product_name = "Назва продукту не повинна бути пустою";
            }

            if (!values.product_group) {
                errors.product_group = "Назва групи не повинна бути пустою";
            }

            if (!values.price) {
                errors.price = "Введіть ціну товару";
            }
            else if (values.price <= 0) {
                errors.price = "Ціна товару повинна бути вища від нуля";
            }

            return errors;
        },
        onSubmit: values => {
            if (values.product_group.toString().includes('-')) {
                var keys = values.product_group.split('-');
                values.product_group = keys[(keys.length - 1)];
            }

            const productCreation = async () => {

                const response = await createProduct(values);

                if (response.status === 201) {
                    toast.current.show({ severity: "success", summary: "Успіх редагування", detail: "Товар " + values.product_name + " успішно створено", life: 3000 });
                    newProductFormik.resetForm();
                    setProductSideBarVisible(false);
                    SelectProductGroup(selectedGroup, lazyState);
                    setReloadData(!reloadData);
                }
                else {
                    toast.current.show({ severity: "error", summary: "Помилка створення", detail: "Товар не створено. Помилка сервера " + response.status, life: 3000 });
                }

            };

            productCreation();
        }
    });

    const getReceptionActPayments = async (id) => {

        const response = await fetchActPayments(location.state.id);

        if (response.status === 200) {
            setActPayments(response.data.results);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання платежів", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getReceptionActHistory = async (id, state) => {

        const response = await fetchReceptionActHistory(id, state);

        console.log(response);

        if (response.status === 200) {
            setReceptionActHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getDocumentsArchive = async (id, lazyState) => {

        const response = await fetchReceptionActDocuments(id, lazyState);

        if (response.status === 200) {
            setDocArchive(response.data.results);
            setDocArchiveTotalRecords(response.data.count);
        }
    }

    const SelectProductGroup = (id, state) => {

        setlazyState(state);
        setSelectedGroup(id);

        setLoading(true);

        const getProductsByGroupId = async () => {

            state.filters.product_group.value = getGroupCode(id);

            const response = await fetchProducts(true, state);

            if (response.status === 200) {
                setProducts(response.data.results);
                setTotalRecords(response.data.count);
            }
            else {
                setProducts([]);
            }

            setLoading(false);
        }

        getProductsByGroupId();
    }

    const items = [
        {
            label: isMobile ? "Деталі" : "Деталі акту прийому",
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        ...(isFinalized
            ? [
                {
                    label: 'Платежі',
                    icon: 'pi pi-money-bill',
                    command: () => {
                        setTabShowed(1);
                        getReceptionActPayments(location.state.id);
                    },
                },
            ]
            : []),
        ...(isEdit
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(2);
                        getReceptionActHistory(location.state.id, historyLazyState);
                    },
                },
                {
                    label: 'Документи',
                    icon: 'pi pi-save',
                    command: () => {
                        setTabShowed(3);
                        getDocumentsArchive(location.state.id, historyLazyState);
                    },
                },
            ]
            : []),
    ];

    const onPage = (event) => {
        event.page = event.page + 1;
        event.sortField = lazyState.sortField;
        event.sortOrder = lazyState.sortOrder;
        event.filters = lazyState.filters;
        SelectProductGroup(selectedGroup, event);
        setlazyState(event);
    };

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getReceptionActHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const onDocArchivePage = (event) => {
        event.page = event.page + 1;
        getDocumentsArchive(location.state.id, event);

        setDocArchiveLazyState(event);
    }

    const AddProductHandler = () => {
        setVisible(true);
        setShowProducts(true);
    }

    const AddProductToTableHandler = rowData => {

        sideBarFormik.setFieldValue('type', rowData.accounting_type);
        sideBarFormik.setFieldValue('product', rowData.product_name);
        sideBarFormik.setFieldValue('product_id', rowData.id);
        sideBarFormik.setFieldValue('catalogue_price', rowData.price);
        sideBarFormik.setFieldValue('catalogue_currency', rowData.currency);
        sideBarFormik.setFieldValue('measurement_units', rowData.measurement_unit);

        setShowProducts(false);
        setShowFields(true);
    };

    const EditFieldHandler = (rowData) => {

        setIsEditField(true);
        setShowProducts(false);
        setShowFields(true);

        const type = rowData.identifier ? "INDIVIDUAL" : "PIECE";

        sideBarFormik.setFieldValue('type', type);
        if (type === "INDIVIDUAL") {
            sideBarFormik.setFieldValue('identifier', rowData.identifier);
        }
        else {
            sideBarFormik.setFieldValue('quantity', rowData.quantity);
        }
        sideBarFormik.setFieldValue('product', rowData.product_name);
        sideBarFormik.setFieldValue('id', rowData.id);
        sideBarFormik.setFieldValue('product_id', rowData.product_id);
        sideBarFormik.setFieldValue('note', rowData.note);
        sideBarFormik.setFieldValue('catalogue_price', rowData.use_product_sale_price ? rowData.custom_sale_price : 0);
        sideBarFormik.setFieldValue('catalogue_currency', rowData.use_product_sale_price ? rowData.custom_sale_price_currency : "UAH");
        sideBarFormik.setFieldValue('custom_sale_price', rowData.custom_sale_price);
        sideBarFormik.setFieldValue('custom_sale_price_currency', rowData.custom_sale_price_currency);        
        sideBarFormik.setFieldValue('measurement_units', rowData.measurement_units);
        sideBarFormik.setFieldValue('price', rowData.price);
        sideBarFormik.setFieldValue('priceUAH', rowData.priceUAH);
        sideBarFormik.setFieldValue('currency', rowData.currency);
        sideBarFormik.setFieldValue('use_product_sale_price', rowData.use_product_sale_price);

        if (rowData.fe_id) {
            sideBarFormik.setFieldValue('fe_id', rowData.fe_id);
        }

        setVisible(true);
    };

    const DeleteFieldHandler = (id, fields, name) => {

        const updatedFields = [...fields];

        const index = fields.findIndex(function (field) {
            return field.fe_id === id
        });

        updatedFields.splice(index, 1);
        formik.setFieldValue(name, updatedFields);
    };

    const closeSideBarHandler = () => {
        setVisible(false);
        setIsEditField(false);
        setShowFields(false);
        sideBarFormik.resetForm();
    }

    const BackToProductsHandler = () => {
        setShowFields(false);
        setShowProducts(true);
        sideBarFormik.resetForm();
    }

    const SetReceptionCurrencyAmount = value => {
        sideBarFormik.setFieldValue('price', value);
        sideBarFormik.setFieldValue('priceUAH', convertSumWithLatestCurrencyRate(sideBarFormik.values.currency, value));
    };

    const setCurrency = value => {
        sideBarFormik.setFieldValue('currency', value);
        sideBarFormik.setFieldValue('custom_sale_price_currency', value);
        if (sideBarFormik.values.price !== "") {
            sideBarFormik.setFieldValue('priceUAH', convertSumWithLatestCurrencyRate(value, sideBarFormik.values.price));
        }
    }

    const UnbindPayment = async (paymentId) => {

        const request = {
            act_id: location.state.id,
            payment_id: paymentId
        }

        const response = await deletePaymentFromAct(request);

        console.log(response);
        if (response.status === 204) {

            const index = actPayments.findIndex(payment => payment.id === paymentId);
            if (index !== -1) {
                // Create a new array with the element removed
                const newPayments = [...actPayments.slice(0, index), ...actPayments.slice(index + 1)];
                console.log(newPayments);

                // Set the updated state
                setActPayments(newPayments);
            }

            toast.current.show({ severity: "success", summary: "Платіж відвязано", detail: "Платіж відвязано від акту", life: 3000 });

        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка відвязки платежу", detail: "Платіж не відвязано від акту. Код помилки: " + response.status, life: 3000 });
        }
    }

    const RecalculateSumWithLatestCurrencyRate = (rowData, type) => {
        const newSumUAH = convertSumWithLatestCurrencyRate(rowData.currency, rowData.price);

        const updatedArray = formik.values[type].map(item => {
            const isMatch = rowData.fe_id
                ? item.fe_id === rowData.fe_id
                : item.id === rowData.id;

            return isMatch
                ? { ...item, priceUAH: newSumUAH }
                : item;
        });

        formik.setFieldValue(type, updatedArray);
    };

    const confirmLeave = (event) => {

        if (formik.values !== actData) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/productsreception", { state: { pageState: location?.state?.pageState } }) }
            });

        }
        else {
            navigate("/productsreception", { state: { pageState: location?.state?.pageState } });
        }
    }

    const confirmRecalculate = (rowData, type) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження перерахунку вартості товару в гривні',
            message: "Вартість товару " + rowData.product_name + " буде перераховано по курсу " + Cookies.get(rowData.currency) + " UAH за " + rowData.currency + ".",
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { RecalculateSumWithLatestCurrencyRate(rowData, type) }
        });
    }

    //#region Templates

    const toolbarLeftData = () => {

        let name = "Створення нового акту прийому";

        if (isEdit) {
            name = "Редагування акту прийому №" + formik.values.act_number;
            if (isFinalized) {
                name = "Інформація про акт прийому №" + formik.values.act_number;
            }
        }

        return !isMobile ?
            <h3>{name}</h3> :
            (!isFinalized ? <Button type="button" icon={`pi ${showActBaseOnMobile ? "pi-chevron-circle-up" : "pi-chevron-circle-down"}`} severity="secondary" outlined onClick={() => setShowActBaseOnMobile(!showActBaseOnMobile)} /> : null);
    }

    const handleCellEditComplete = (e, arrayName) => {
        const rowIndex = e.index ?? e.rowIndex;

        const updated = [...formik.values[arrayName]];
        updated[rowIndex] = {
            ...updated[rowIndex],
            [e.field]: e.newValue
        };

        formik.setFieldValue(arrayName, updated);
    };

    const contentToolbarRightTemplate = () => {
        return (<>
            <div className="flex flex-wrap gap-2">
                <Button label={`${isMobile ? "" : "+Додати товар"}`} icon={`${isMobile ? "pi pi-plus" : null}`} severity="success" className={commonStyle.addButton} type="button" onClick={AddProductHandler} />
            </div>
        </>);
    }

    const actionBodyTemplate = (rowData) => {
        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-plus"
                type="button"
                className={`p-button-rounded p-button-success ${commonStyle.addButton}`}
                tooltipOptions={{ showOnDisabled: true }}
                onClick={() => AddProductToTableHandler(rowData)}
            />
        </div>
        );
    };

    const saleCurrencyTemplate = (rowData) => {
        return formatCurrency(rowData.custom_sale_price, rowData.custom_sale_price_currency);
    }

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap text-align-center align-items-center">
                <span className={!isMobile ? "text-xl text-900 font-bold" : "font-bold"}>{tablename}</span>
            </div>
        );
    }

    const sideBarTableHeader = (tableName) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                {setTableHeader(tableName)}
                <Button
                    icon="pi pi-plus"
                    type="button"
                    className={`p-button-rounded p-button-success ${commonStyle.addButton}`}
                    tooltipOptions={{ position: "left" }}
                    tooltip="Створити товар"
                    onClick={() => {
                        newProductFormik.setFieldValue("product_group", selectedGroup)
                        setProductSideBarVisible(true)
                    }}
                />
            </div>
        );
    }

    const tableActionBodyTemplate = (rowData) => {

        var isId = Object.hasOwn(rowData, 'identifier');

        return (<div className="flex flex-wrap gap-2">
            {!isFinalized && <>
                <Button
                    icon="pi pi-money-bill"
                    type="button"
                    className={`p-button-rounded p-button-success ${commonStyle.addButton}`}
                    tooltip="Перерахувати по курсу на сьогодні"
                    tooltipOptions={{ position: "top" }}
                    size="small"
                    onClick={() => confirmRecalculate(rowData, isId ? "identified_products" : "unidentified_products")}
                />
                <Button
                    icon="pi pi-trash"
                    type="button"
                    className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                    tooltip="Видалити"
                    tooltipOptions={{ showOnDisabled: true, position: "top" }}
                    size="small"
                    onClick={() => DeleteFieldHandler(rowData.fe_id, isId ? formik.values.identified_products : formik.values.unidentified_products, isId ? "identified_products" : "unidentified_products")}
                />
                <Button
                    icon="pi pi-pencil"
                    type="button"
                    className={`p-button-rounded p-button-warning ${commonStyle.warningTag}`}
                    tooltip="Редагувати"
                    tooltipOptions={{ position: "top" }}
                    size="small"
                    onClick={() => EditFieldHandler(rowData)}
                />
            </>}
        </div>
        );
    };

    const TableFooter = (data) => {

        const totalValue = data.reduce((accumulator, element) => accumulator + element.priceUAH * (element.quantity === undefined ? 1 : element.quantity), 0);

        return (
            <div className={commonStyle.footerContainer}>
                <label>Cума: {formatCurrency(totalValue, "UAH")}</label>
            </div>)
    }

    const mobileProductBody = (rowData) => {
        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-12">
                        <div className="flex-column">
                            <div className="font-bold">x{rowData.quantity} {rowData.product_name}</div>
                            <div>{rowData.note}</div>
                            <div>{rowData.identifier}</div>
                            <div>Ціна за од: {formatCurrency(rowData.price, rowData.currency)}</div>
                            <div>Ціна за од, грн: {formatCurrency(rowData.priceUAH, "UAH")}</div>
                            <div>{saleCurrencyTemplate}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {tableActionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    const HandleCagentCreation = (id) => {
        formik.setFieldValue("cagent", id);
    }

    //#endregion

    console.log(formik.values);

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={isFinalized} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} />
        <ConfirmDialog group="headless" />
        <TabMenu model={items} />
        {tabShowed === 0 &&
            <div className="grid justify-content-center">
                {(isMobile && (isFinalized || !showActBaseOnMobile)) ? (<div className="col-12 ml-5 mt-2 text-lg">
                    {formik.values.act_number && <div className="mt-3"><span className="font-bold">Aкт: </span>{"№" + formik.values.act_number}</div>}
                    <div><span className="font-bold">Контрагент: </span> {getPartnerLabel(formik.values.cagent)}</div>
                    <div><span className="font-bold">Точка продажу: </span>{getDivisionLabel(formik.values.division)}</div>
                    <div><span className="font-bold">Дата акту: </span>{formatShortDate(formik.values.act_date)}</div>
                    <div><span className="font-bold">Очікувана дата оплати: </span>{formatShortDate(formik.values.pay_due_date)}</div>
                    <div><span className="font-bold">Статус: </span>{formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"}</div>
                    {isFinalized && <div><span className="font-bold">Статус оплати: </span>{getPayStatusLabel(formik.values.pay_status)}</div>}
                </div>) :
                    (showActBaseOnMobile && (<div className={`${!isMobile ? commonStyle.leftMenu : commonStyle.mobileActDetailsMenu} ${isMobile ? "col-12 flex flex-column align-items-center" : "col-3"}`}>
                        <DropdownInput
                            formik={formik}
                            paramName={"cagent"}
                            context={ctx.enums.partners.data}
                            onChange={(val) => formik.setFieldValue("cagent", val)}
                            label={"Контрагент"}
                            isDisabled={isFinalized}
                            isMobile={isMobile}
                            addButton={true}
                            addButtonTooltip={"Додати контрагента"}
                            addButtonAction={() => setCagentCreationSidebarVisible(true)}
                        />
                        <DropdownInput
                            formik={formik}
                            paramName={"division"}
                            context={ctx.enums.divisions.data}
                            onChange={(val) => formik.setFieldValue("division", val)}
                            label={"Точка продажу"}
                            isDisabled={isFinalized}
                            isMobile={isMobile}
                            mandatory />
                        <CalendarInput formik={formik} paramName={"act_date"} label={"Дата акту"} isDisabled={isFinalized} isMobile={isMobile} />
                        <CalendarInput formik={formik} paramName={"pay_due_date"} label={"Очікувана дата оплати"} isDisabled={isFinalized} isMobile={isMobile} />
                        <ActNumberWithAutogenerateInput formik={formik} showAutogenerate={!isFinalized} isDisabled={isFinalized} />
                        <div className={`${commonStyle.formInput} ${!isMobile ? "" : "w-11"}`}>
                            <div className="p-inputgroup flex-column">
                                <FloatLabel>
                                    <InputText value={formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"}
                                        disabled
                                        className="w-full" />
                                    <label>Статус</label>
                                </FloatLabel>
                            </div>
                        </div>
                        {isFinalized && <div className={`${commonStyle.formInput} ${!isMobile ? "" : "w-11"}`}>
                            <div className="p-inputgroup flex-column">
                                <FloatLabel>
                                    <InputText value={getPayStatusLabel(formik.values.pay_status)}
                                        disabled
                                        className="w-full" />
                                    <label>Статус оплати</label>
                                </FloatLabel>
                            </div>
                        </div>}
                    </div>))}
                <div className={`${isMobile ? "col-12" : "col-9"}`}>
                    {!isFinalized && <Toolbar className="mb-4" end={contentToolbarRightTemplate} />}
                    {(!isMobile && formik.values.identified_products.length > 0) && <DataTable value={formik.values.identified_products} header={setTableHeader("Товари індивідуального обліку")}
                        footer={() => TableFooter(formik.values.identified_products)} editMode="cell" tableStyle={{ minWidth: '50rem' }}>
                        <Column field="product_name" header="Продукт" style={{ width: '25%' }} />
                        <Column field="note" header="Примітка" style={{ width: '15%' }} />
                        <Column field="identifier" header="Ідентифікатор" editor={(options) => textEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "identified_products")}
                            style={{ width: '15%' }} />
                        <Column field="price" header="Ціна в валюті розрахунку" editor={(options) => numberEditor(options, 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "identified_products")}
                            body={rowData => formatCurrency(rowData.price, rowData.currency)} style={{ width: '10%' }} />
                        <Column field="priceUAH" header="Ціна, грн" body={rowData => formatCurrency(rowData.priceUAH, "UAH")} style={{ width: '10%' }} />
                        <Column field="custom_sale_price" header="Ціна продажу в валюті" editor={(options) => numberEditor(options, 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "identified_products")}
                            body={saleCurrencyTemplate} style={{ width: '10%' }} />
                        <Column field="action" body={tableActionBodyTemplate} style={{ width: '15%' }} />
                    </DataTable>}
                    {(isMobile && formik.values.identified_products.length > 0) && <DataTable value={formik.values.identified_products} header={setTableHeader("Товари індивідуального обліку")}
                        footer={() => TableFooter(formik.values.identified_products)}>
                        <Column field="product_name" headerStyle={{ display: 'none' }} body={(rowData) => mobileProductBody(rowData)} />
                    </DataTable>}
                    {(!isMobile && formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.unidentified_products} header={setTableHeader("Товари поштучного обліку")}
                        footer={() => TableFooter(formik.values.unidentified_products)} editMode="cell" tableStyle={{ minWidth: '50rem' }}>
                        <Column field="product_name" header="Продукт" style={{ width: '25%' }} />
                        <Column field="note" header="Примітка" style={{ width: '15%' }} />
                        <Column field="quantity" header="Кількість"
                            editor={(options) => numberEditor(options, options.rowData.measurement_unit === "PIECES" ? 0 : 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "unidentified_products")}
                            body={(rowData) => formatQuantityWithMeasurement(rowData.quantity, rowData.measurement_units)} style={{ width: '15%' }} />
                        <Column field="price" header="Ціна в валюті розрахунку" editor={(options) => numberEditor(options, 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "unidentified_products")}
                            body={rowData => formatCurrency(rowData.price, rowData.currency)} style={{ width: '10%' }} />
                        <Column field="priceUAH" header="Ціна в гривні" body={(rowData => formatCurrency(rowData.priceUAH, "UAH"))} style={{ width: '10%' }} />
                        <Column field="custom_sale_price" header="Ціна продажу в валюті" editor={(options) => numberEditor(options, 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "unidentified_products")}
                            body={saleCurrencyTemplate} style={{ width: '10%' }} />
                        <Column field="action" body={tableActionBodyTemplate} style={{ width: '15%' }} />
                    </DataTable>}
                    {(isMobile && formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.unidentified_products} header={setTableHeader("Товари поштучного обліку")}
                        footer={() => TableFooter(formik.values.unidentified_products)}>
                        <Column field="product_name" headerStyle={{ display: 'none' }} body={(rowData) => mobileProductBody(rowData)} />
                    </DataTable>}
                    {(formik.values.unidentified_products.length > 0 || formik.values.identified_products.length > 0) && <div className={commonStyle.footerContainer}>
                        <h3>Загальна сума акту: {formatCurrency(totaLActSum, "UAH")}</h3>
                    </div>}
                </div>
            </div>}
        {tabShowed === 1 && isFinalized && <ActPayments isMobile={isMobile} payments={actPayments} onUnbindClick={UnbindPayment} />}
        {tabShowed === 2 && <HistoryElement data={receptionActHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={true} />}
        {tabShowed === 3 && <DocumentArchiveTable documents={docArchive} lazyState={docArchiveLazyState} onPage={onDocArchivePage} totalRecords={docArchiveTotalRecords} toast={toast} />}
        <Sidebar visible={visible} position="right"
            onHide={() => closeSideBarHandler()}
            className={`${!isMobile ? commonStyle.shortSideBar : "w-full"} ${productSideBarVisible && isLargeScreen ? commonStyle.moveLeft : ''}`}>
            {(showfields && !isEditField) && <Button label="<<<" type="button" className={commonStyle.blankButton} onClick={() => BackToProductsHandler()} />}
            <form onSubmit={sideBarFormik.handleSubmit}>
                {showproducts && (<>
                    {selectedGroup === null && <label>Виберіть групу товарів для вибору товару</label>}
                    <div className="p-inputgroup flex-column mt-4">
                        <FloatLabel>
                            <TreeSelect
                                name="sel_product_group"
                                value={selectedGroup}
                                onChange={(e) => SelectProductGroup(e.value, newState)}
                                options={sortedGroups}
                                className="w-full" />
                            <label>Назва групи</label>
                        </FloatLabel>
                    </div>
                    {selectedGroup !== null && <DataTable value={products}
                        header={sideBarTableHeader("Товари")}
                        lazy
                        className="mt-3"
                        emptyMessage="Товари не знайдено"
                        rows={lazyState.rows} paginator onPage={onPage} first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[20, 50]}>
                        <Column field="product_name" header="Продукт" style={{ width: '90%' }} />
                        <Column field="action" body={actionBodyTemplate} style={{ width: '10%' }} />
                    </DataTable>}
                </>)}
                {showfields && (<>
                    <TextInput formik={sideBarFormik} paramName={"product"} label={"Назва товару"} isDisabled={true} customStyle="w-full" />
                    {sideBarFormik.values.type === "INDIVIDUAL" && <TextInput formik={sideBarFormik} paramName={"identifier"} label={"Ідентифікатор"} customStyle="w-full" />}
                    {sideBarFormik.values.type === "PIECE" &&
                        <NumberInput
                            label="Кількість"
                            value={sideBarFormik.values.quantity}
                            onChange={(val) => sideBarFormik.setFieldValue("quantity", val)}
                            errors={sideBarFormik.errors.quantity}
                            touched={sideBarFormik.touched.quantity}
                            digits={sideBarFormik.values.measurement_units === "PIECES" ? 0 : 2}
                            customStyle="w-full"
                        />}
                    <TextInput formik={sideBarFormik} paramName={"note"} label={"Примітка"} customStyle="w-full" />
                    <DropdownInput
                        formik={sideBarFormik}
                        paramName={"currency"}
                        context={systemCurrenciesDropdown}
                        onChange={(val) => setCurrency(val)}
                        label={"Валюта"}
                        customStyle="w-full"
                    />
                    <NumberInput
                        label="Ціна в валюті розрахунку, за одиницю"
                        value={sideBarFormik.values.price}
                        onChange={(val) => SetReceptionCurrencyAmount(val)}
                        errors={sideBarFormik.errors.price}
                        touched={sideBarFormik.touched.price}
                        digits={2}
                        customStyle="w-full"
                    />
                    {(sideBarFormik.values.currency && sideBarFormik.values.currency !== "UAH") && <TextInput formik={sideBarFormik} paramName={"priceUAH"} label={"Ціна в гривні, за одиницю"} customStyle="w-full" />}
                    <CheckboxInput formik={sideBarFormik} paramName={"use_product_sale_price"} label={`Використовувати ціну продажу з довідника (${sideBarFormik.values.catalogue_price ?? ""} ${sideBarFormik.values.catalogue_currency ?? ""})`} />
                    {!sideBarFormik.values.use_product_sale_price && <>
                        <DropdownInput
                            formik={sideBarFormik}
                            paramName={"custom_sale_price_currency"}
                            context={systemCurrenciesDropdown}
                            onChange={(val) => sideBarFormik.setFieldValue("custom_sale_price_currency", findKeyByValue(systemCurrenciesDropdown, val))}
                            label={"Валюта продажу"}
                            customStyle="w-full" />
                        <NumberInput
                            label="Ціна продажу в валюті розрахунку, за одиницю"
                            value={sideBarFormik.values.custom_sale_price}
                            onChange={(val) => sideBarFormik.setFieldValue("custom_sale_price", val)}
                            errors={sideBarFormik.errors.custom_sale_price}
                            touched={sideBarFormik.touched.custom_sale_price}
                            digits={2}
                            customStyle="w-full"
                        />
                    </>}
                    <div>
                        <Button label={isEditField ? "Редагувати" : "Додати"} severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
                    </div>
                </>)}
            </form>
        </Sidebar>
        <Sidebar
            visible={productSideBarVisible}
            header={<h2>Створення нового товару</h2>}
            position="right"
            onHide={() => setProductSideBarVisible(false)} className={`${commonStyle.sidebarmoved} ${commonStyle.shortSideBar} ${!isLargeScreen && 'sidebar-mobile'}`}>
            <form onSubmit={newProductFormik.handleSubmit}>
                <div className={commonStyle.sideBarInput}>
                    <div className="p-inputgroup flex-column">
                        <FloatLabel>
                            <TreeSelect
                                name="product_group"
                                value={newProductFormik.values.product_group}
                                onChange={(e) => newProductFormik.setFieldValue("product_group", e.value)}
                                options={sortedGroups}
                                showClear
                                className={newProductFormik.errors.product_group && newProductFormik.touched.product_group ? 'p-invalid w-full' : 'w-full'} />
                            <label>Назва групи</label>
                        </FloatLabel>
                        {newProductFormik.errors.product_group && newProductFormik.touched.product_group && (<small className={commonStyle.errorSmall}>{newProductFormik.errors.product_group}</small>)}
                    </div>
                </div>
                <TextInput formik={newProductFormik} paramName={"product_name"} label={"Назва товару"} customStyle="w-full" />
                <TextInput formik={newProductFormik} paramName={"product_article"} label={"Артикул"} customStyle="w-full" />
                <CurrencyAmountInput
                    amount={newProductFormik.values.price}
                    currency={newProductFormik.values.currency}
                    onCurrencyChange={val => newProductFormik.setFieldValue('currency', val)}
                    onAmountChange={val => newProductFormik.setFieldValue('price', val)}
                    errors={newProductFormik.errors.price}
                    touched={newProductFormik.touched.price}
                    customStyle="w-full"
                />
                <CheckboxInput formik={newProductFormik} paramName={"is_active"} label={"Активувати товар при створенні"} />
                <div>
                    <Button label="Додати" severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
                </div>
            </form>
        </Sidebar>
        <CounterAgentCreationSidebar visible={cagentCreationSidebarVisible} onHide={() => setCagentCreationSidebarVisible(false)}
            toast={toast} ctx={ctx} componentKey={location.pathname} onCreate={(id) => HandleCagentCreation(id)} isPartner />
    </form>);
}

export default NewProductsReception;